import { Link } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { Heart } from 'lucide-react';

/** The copy is `aria-hidden` and the link carries the name, or it would be the phrase read eight times over. */
export function Marquee() {
	const { t } = useLingui();
	const item = (
		<span className="flex shrink-0 items-center gap-8 pr-8">
			<span className="text-olive text-4xl font-semibold tracking-tight uppercase md:text-6xl">
				{t`Make an impact today`}
			</span>
			<span className="grid size-8 shrink-0 place-items-center rounded-full bg-white md:size-10">
				<Heart className="text-ink size-4 fill-current md:size-5" />
			</span>
		</span>
	);
	return (
		<Link
			to="/www/contact"
			aria-label={t`Make an impact today`}
			className="bg-ink block overflow-hidden py-6 transition-opacity hover:opacity-90 md:py-8"
		>
			<div className="flex w-max motion-safe:animate-[new-marquee_24s_linear_infinite]" aria-hidden>
				<div className="flex">
					{Array.from({ length: 4 }).map((_, i) => (
						// oxlint-disable-next-line react/no-array-index-key
						<div key={i} className="flex">
							{item}
						</div>
					))}
				</div>
				<div className="flex">
					{Array.from({ length: 4 }).map((_, i) => (
						// oxlint-disable-next-line react/no-array-index-key
						<div key={i} className="flex">
							{item}
						</div>
					))}
				</div>
			</div>
		</Link>
	);
}
